import { useStore } from "react-admin";
import { colorSchemeMap } from "../models/color-scheme";

export const useColorScheme = () => {
  const [colorSchemeId] = useStore('map.imageColorSchemeId', 0);
  const colorScheme = colorSchemeMap[colorSchemeId];
  if (!colorScheme) {
    throw new Error(`Can't find color scheme for id: ${colorSchemeId}`);
  }
  return colorScheme;
};
